// extracted by mini-css-extract-plugin
export default {"cards":"stayle_cards__mokHu"};